if (!customElements.get('bundle-addon')) {
  class BundleAddon extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.bundle-addon__toggle');
      this.list = this.querySelector('.bundle-addon__list');
      this.items = this.querySelectorAll('.bundle-addon__item');
      this.selectionsContainer = this.querySelector('[data-addon-selections]');
      this.selectedAddons = [];
      this.maxAddons = 2;

      this.toggle.addEventListener('click', () => this.toggleList());

      this.items.forEach((item) => {
        item.addEventListener('click', () => this.addItem(item));
      });
    }

    toggleList() {
      var isOpen = !this.list.hidden;
      this.list.hidden = isOpen;
      this.toggle.setAttribute('aria-expanded', String(!isOpen));
    }

    addItem(item) {
      if (this.selectedAddons.length >= this.maxAddons) return;

      var addon = {
        variantId: item.dataset.variantId,
        title: item.dataset.productTitle,
        image: item.dataset.productImage,
        price: item.dataset.productPrice
      };

      this.selectedAddons.push(addon);
      this.renderSelections();
      this.list.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');

      if (this.selectedAddons.length >= this.maxAddons) {
        this.toggle.style.display = 'none';
      }
    }

    removeItem(index) {
      this.selectedAddons.splice(index, 1);
      this.renderSelections();
      this.toggle.style.display = '';
    }

    renderSelections() {
      var self = this;
      this.selectionsContainer.innerHTML = '';

      this.selectedAddons.forEach(function (addon, index) {
        var el = document.createElement('div');
        el.className = 'bundle-addon__selection';
        el.innerHTML =
          '<img src="' + addon.image + '" alt="' + addon.title + '" class="bundle-addon__selected-img" width="40" height="40">' +
          '<span class="bundle-addon__selected-name">' + addon.title + ' (' + addon.price + ')</span>' +
          '<button type="button" class="bundle-addon__remove" aria-label="Remove ' + addon.title + '">' +
            '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">' +
              '<path d="M1 1l8 8M9 1l-8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
            '</svg>' +
          '</button>';

        el.querySelector('.bundle-addon__remove').addEventListener('click', function () {
          self.removeItem(index);
        });

        self.selectionsContainer.appendChild(el);
      });
    }

    getSelectedAddons() {
      return this.selectedAddons;
    }
  }

  customElements.define('bundle-addon', BundleAddon);
}

// Bundle submit button handler
document.addEventListener('DOMContentLoaded', function () {
  var submitBtn = document.querySelector('.bundle-submit-btn');
  if (!submitBtn) return;

  submitBtn.addEventListener('click', function () {
    if (submitBtn.disabled || submitBtn.getAttribute('aria-disabled') === 'true') return;

    submitBtn.setAttribute('aria-disabled', 'true');
    submitBtn.classList.add('loading');
    var spinner = submitBtn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var bundleVariantId = submitBtn.dataset.variantId;
    var addon = document.querySelector('bundle-addon');
    var addons = addon ? addon.getSelectedAddons() : [];

    // Generate a unique ID to link the bundle with its add-ons
    var addonGroupId = Date.now().toString(36) + Math.random().toString(36).substr(2, 4);

    var items = [{
      id: parseInt(bundleVariantId),
      quantity: 1,
      properties: addons.length > 0 ? { '_starter-addon-group': addonGroupId } : {}
    }];

    addons.forEach(function (a) {
      items.push({
        id: parseInt(a.variantId),
        quantity: 1,
        properties: {
          '_starter-addon-group': addonGroupId,
          '_starter-addon-item': 'true'
        }
      });
    });

    var body = { items: items };

    if (cart) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      cart.setActiveElement(document.activeElement);
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (response.status) {
          var errorWrapper = document.querySelector('.product-form__error-message-wrapper');
          var errorMsg = document.querySelector('.product-form__error-message');
          if (errorWrapper && errorMsg) {
            errorMsg.textContent = response.description || response.message;
            errorWrapper.hidden = false;
          }
          return;
        }

        if (typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'bundle-addon',
            cartData: response
          });
        }

        if (cart) {
          cart.renderContents(response);
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch(function (e) { console.error(e); })
      .finally(function () {
        submitBtn.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        submitBtn.removeAttribute('aria-disabled');
      });
  });
});
